module.exports = __webpack_public_path__ + "img/vibirajte-mob.54ccd6c6.png";